import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyGetCityLocationQuery,
  useLazyGetStateCitiesQuery,
  useLazyOwnerListQuery,
  useLazyPropertyCreateQuery,
  useOwnerCreateMutation,
  useOwnerEditMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const PropertyOwner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const types = location?.state?.type;

  const [createList, setCreateList] = useState({});
  const [cityList, setCityList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [state_id, setstate_id] = useState("");
  const [city_id, setcity_id] = useState("");
  const [location_id, setlocation_id] = useState("");
  const [state_idErr, setstate_idErr] = useState(false);
  const [city_idErr, setcity_idErr] = useState(false);
  const [location_idErr, setlocation_idErr] = useState(false);
  const [name, setname] = useState("");
  const [nameErr, setnameErr] = useState(false);
  const [email, setemail] = useState("");
  const [emailErr, setemailErr] = useState(false);
  const [mobile, setmobile] = useState("");
  const [mobileErr, setmobileErr] = useState(false);
  const [contact_number_1, setcontact_number_1] = useState("");
  const [contact_number_1Err, setcontact_number_1Err] = useState(false);
  const [contact_number_2, setcontact_number_2] = useState("");
  const [contact_number_2Err, setcontact_number_2Err] = useState(false);
  const [street, setstreet] = useState("");
  const [streetErr, setstreetErr] = useState(false);
  const [apartment, setapartment] = useState("");
  const [apartmentErr, setapartmentErr] = useState(false);
  const [block_no, setblock_no] = useState("");
  const [block_noErr, setblock_noErr] = useState(false);
  const [door_no, setdoor_no] = useState("");
  const [door_noErr, setdoor_noErr] = useState(false);
  const [pin_code, setpin_code] = useState("");
  const [pin_codeErr, setpin_codeErr] = useState(false);
  const [gst_number, setgst_number] = useState("");
  const [gst_numberErr, setgst_numberErr] = useState(false);
  const [gst_name, setgst_name] = useState("");
  const [gst_nameErr, setgst_nameErr] = useState(false);
  const [gst_address, setgst_address] = useState("");
  const [gst_addressErr, setgst_addressErr] = useState(false);
  const [gst_contact_number, setgst_contact_number] = useState("");
  const [gst_contact_numberErr, setgst_contact_numberErr] = useState(false);
  const [gst_email, setgst_email] = useState("");
  const [gst_emailErr, setgst_emailErr] = useState(false);
  const [bank_name, setbank_name] = useState("");
  const [bank_nameErr, setbank_nameErr] = useState(false);
  const [account_holder_name, setaccount_holder_name] = useState("");
  const [account_holder_nameErr, setaccount_holder_nameErr] = useState(false);
  const [account_number, setaccount_number] = useState("");
  const [account_numberErr, setaccount_numberErr] = useState(false);
  const [branch, setbranch] = useState("");
  const [branchErr, setbranchErr] = useState(false);
  const [ifsc_code, setifsc_code] = useState("");
  const [ifsc_codeErr, setifsc_codeErr] = useState(false);
  const [upi_id, setupi_id] = useState("");
  const [upi_idErr, setupi_idErr] = useState(false);
  const [gpay_number, setgpay_number] = useState("");
  const [gpay_numberErr, setgpay_numberErr] = useState(false);
  const [phone_pay_number, setphone_pay_number] = useState("");
  const [phone_pay_numberErr, setphone_pay_numberErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [propertyCreateApi] = useLazyPropertyCreateQuery();
  const [getStateCitiesApi] = useLazyGetStateCitiesQuery();
  const [getCityLocationApi] = useLazyGetCityLocationQuery();
  const [ownerListApi] = useLazyOwnerListQuery();
  const [ownerCreateApi] = useOwnerCreateMutation();
  const [ownerEditApi] = useOwnerEditMutation();

  const getPropertyCreate = () => {
    propertyCreateApi()
      .unwrap()
      .then((res) => {
        setCreateList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPropertyCreate();
  }, []);

  const getCities = (id) => {
    getStateCitiesApi(id)
      .unwrap()
      .then((res) => {
        setstate_id(id);
        setCityList(res?.cities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocation = (id) => {
    getCityLocationApi(id)
      .unwrap()
      .then((res) => {
        setcity_id(id);
        setLocationList(res?.locations);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getDetatils = () => {
    dispatch(saveLoader(true));
    ownerListApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        let data = res?.owner;
        let bank = res?.owner?.bank;

        if (data?.name) {
          setname(data?.name);
        }
        if (data?.email) {
          setemail(data?.email);
        }

        if (data?.mobile) {
          setmobile(data?.mobile);
        }

        if (data?.contact_number_1) {
          setcontact_number_1(data?.contact_number_1);
        }

        if (data?.contact_number_2) {
          setcontact_number_2(data?.contact_number_2);
        }

        if (data?.state_id) {
          getCities(data?.state_id);
        }

        if (data?.city_id) {
          getLocation(data?.city_id);
        }

        if (data?.location_id) {
          setlocation_id(data?.location_id);
        }

        if (data?.street) {
          setstreet(data?.street);
        }

        if (data?.apartment) {
          setapartment(data?.apartment);
        }

        if (data?.block_no) {
          setblock_no(data?.block_no);
        }

        if (data?.door_no) {
          setdoor_no(data?.door_no);
        }
        if (data?.pin_code) {
          setpin_code(data?.pin_code);
        }
        if (data?.gst_number) {
          setgst_number(data?.gst_number);
        }
        if (data?.gst_entity_name) {
          setgst_name(data?.gst_entity_name);
        }
        if (data?.gst_address) {
          setgst_address(data?.gst_address);
        }
        if (data?.gst_contact_number) {
          setgst_contact_number(data?.gst_contact_number);
        }

        if (data?.gst_contact_email) {
          setgst_email(data?.gst_contact_email);
        }

        if (bank?.bank_name) {
          setbank_name(bank?.bank_name);
        }
        if (bank?.account_holder_name) {
          setaccount_holder_name(bank?.account_holder_name);
        }
        if (bank?.account_number) {
          setaccount_number(bank?.account_number);
        }
        if (bank?.branch) {
          setbranch(bank?.branch);
        }
        if (bank?.ifsc_code) {
          setifsc_code(bank?.ifsc_code);
        }
        if (bank?.upi_id) {
          setupi_id(bank?.upi_id);
        }
        if (bank?.gpay_number) {
          setgpay_number(bank?.gpay_number);
        }
        if (bank?.phonepe_number) {
          setphone_pay_number(bank?.phonepe_number);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getDetatils();
    }
  }, []);

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      email?.length == 0 ||
      mobile?.length == 0 ||
      contact_number_1?.length == 0 ||
      contact_number_2?.length == 0 ||
      state_id?.length == 0 ||
      city_id?.length == 0 ||
      location_id?.length == 0 ||
      street?.length == 0 ||
      apartment?.length == 0 ||
      block_no?.length == 0 ||
      door_no?.length == 0 ||
      pin_code?.length == 0 ||
      gst_number?.length == 0 ||
      gst_name?.length == 0 ||
      gst_address?.length == 0 ||
      gst_contact_number?.length == 0 ||
      gst_email?.length == 0 ||
      bank_name?.length == 0 ||
      account_holder_name?.length == 0 ||
      account_number?.length == 0 ||
      branch?.length == 0 ||
      ifsc_code?.length == 0 ||
      upi_id?.length == 0 ||
      gpay_number?.length == 0 ||
      phone_pay_number?.length == 0
    ) {
      setnameErr(true);
      setemailErr(true);
      setmobileErr(true);
      setcontact_number_1Err(true);
      setcontact_number_2Err(true);
      setstate_idErr(true);
      setcity_idErr(true);
      setlocation_idErr(true);
      setstreetErr(true);
      setapartmentErr(true);
      setblock_noErr(true);
      setdoor_noErr(true);
      setpin_codeErr(true);
      setgst_numberErr(true);
      setgst_nameErr(true);
      setgst_addressErr(true);
      setgst_contact_numberErr(true);
      setgst_emailErr(true);
      setbank_nameErr(true);
      setaccount_holder_nameErr(true);
      setaccount_numberErr(true);
      setbranchErr(true);
      setifsc_codeErr(true);
      setupi_idErr(true);
      setgpay_numberErr(true);
      setphone_pay_numberErr(true);
    } else {
      const formdata = new FormData();
      formdata.append("name", name);
      formdata.append("email", email);
      formdata.append("mobile", mobile);
      formdata.append("contact_number_1", contact_number_1);
      formdata.append("contact_number_2", contact_number_2);
      formdata.append("state_id", state_id);
      formdata.append("city_id", city_id);
      formdata.append("location_id", location_id);
      formdata.append("street", street);
      if (apartment) {
        formdata.append("apartment", apartment);
      }
      if (block_no) {
        formdata.append("block_no", block_no);
      }
      if (gst_number) {
        formdata.append("gst_number", gst_number);
      }
      if (gst_name) {
        formdata.append("gst_name", gst_name);
      }
      if (gst_address) {
        formdata.append("gst_address", gst_address);
      }
      if (gst_email) {
        formdata.append("gst_email", gst_email);
      }
      if (gst_contact_number) {
        formdata.append("gst_contact_number", gst_contact_number);
      }
      if (upi_id) {
        formdata.append("upi_id", upi_id);
      }
      if (gpay_number) {
        formdata.append("gpay_number", gpay_number);
      }
      if (phone_pay_number) {
        formdata.append("phone_pay_number", phone_pay_number);
      }
      formdata.append("door_no", door_no);
      formdata.append("pin_code", pin_code);
      if (bank_name) {
        formdata.append("bank_name", bank_name);
      }
      if (account_holder_name) {
        formdata.append("account_holder_name", account_holder_name);
      }
      if (branch) {
        formdata.append("branch", branch);
      }
      if (account_number) {
        formdata.append("account_number", account_number);
      }
      if (ifsc_code) {
        formdata.append("ifsc_code", ifsc_code);
      }

      if (location?.state?.data?.id) {
        formdata.append("_method", "PUT");
        dispatch(saveLoader(true));
        setBtn(true);
        ownerEditApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        ownerCreateApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={types == "edit" ? "edit-property-owner" : "add-property-owner"}
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setname(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  E-mail
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setemail(e.target.value)}
                  value={email}
                />
              </div>
              {email?.length == 0 && emailErr && (
                <p className="err">Enter E-mail</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Mobile Number*
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmobile(e.target.value)}
                  value={mobile}
                  type={"number"}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    if (e.target.value.length !== 10) {
                      e.target.setCustomValidity("invalid Number");
                    } else if (e.target.value.length == 10) {
                      e.target.setCustomValidity("");

                      setmobile(e.target.value);
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  maxlength={10}
                />
              </div>
              {mobile?.length == 0 && mobileErr && (
                <p className="err">Enter Mobile</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Contact Number1
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setcontact_number_1(e.target.value)}
                  value={contact_number_1}
                  type={"number"}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    if (e.target.value.length !== 10) {
                      e.target.setCustomValidity("invalid Number");
                    } else if (e.target.value.length == 10) {
                      e.target.setCustomValidity("");

                      setcontact_number_1(e.target.value);
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  maxlength={10}
                />
              </div>
              {contact_number_1?.length == 0 && contact_number_1Err && (
                <p className="err">Enter Contact Number1</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Contact Number2
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setcontact_number_2(e.target.value)}
                  value={contact_number_2}
                  type={"number"}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    if (e.target.value.length !== 10) {
                      e.target.setCustomValidity("invalid Number");
                    } else if (e.target.value.length == 10) {
                      e.target.setCustomValidity("");

                      setcontact_number_2(e.target.value);
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  maxlength={10}
                />
              </div>
              {contact_number_2?.length == 0 && contact_number_2Err && (
                <p className="err">Enter Contact Number2</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  State
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => getCities(e.target.value)}
                  value={state_id}
                >
                  <option value={""} disabled>
                    Select State
                  </option>
                  {createList?.states?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {state_id?.length == 0 && state_idErr && (
                <p className="err">Select State</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  City
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => getLocation(e.target.value)}
                  value={city_id}
                >
                  <option value={""} disabled>
                    Select City
                  </option>
                  {cityList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {city_id?.length == 0 && city_idErr && (
                <p className="err">Select City</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Location
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setlocation_id(e.target.value)}
                  value={location_id}
                >
                  <option value={""} disabled>
                    Select Location
                  </option>
                  {locationList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {location_id?.length == 0 && location_idErr && (
                <p className="err">Select Location</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Street
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setstreet(e.target.value)}
                  value={street}
                />
              </div>
              {street?.length == 0 && streetErr && (
                <p className="err">Enter Street</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Appartment
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setapartment(e.target.value)}
                  value={apartment}
                />
              </div>
              {apartment?.length == 0 && apartmentErr && (
                <p className="err">Enter Appartment</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Block Floor
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setblock_no(e.target.value)}
                  value={block_no}
                />
              </div>
              {block_no?.length == 0 && block_noErr && (
                <p className="err">Enter Block Floor</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Door No
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setdoor_no(e.target.value)}
                  value={door_no}
                />
              </div>
              {door_no?.length == 0 && door_noErr && (
                <p className="err">Enter Door No</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Pincode
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setpin_code(e.target.value)}
                  value={pin_code}
                  type={"number"}
                />
              </div>
              {pin_code?.length == 0 && pin_codeErr && (
                <p className="err">Enter Pincode</p>
              )}
            </div>
            <div className="col-md-12 mb-3">
              <div className="head-dest d-flex ac-jb">GST Details</div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gst Number
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgst_number(e.target.value)}
                  value={gst_number}
                />
              </div>
              {gst_number?.length == 0 && gst_numberErr && (
                <p className="err">Enter Gst Number</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gst Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgst_name(e.target.value)}
                  value={gst_name}
                />
              </div>
              {gst_name?.length == 0 && gst_nameErr && (
                <p className="err">Enter Gst Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gst Address
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgst_address(e.target.value)}
                  value={gst_address}
                />
              </div>
              {gst_address?.length == 0 && gst_addressErr && (
                <p className="err">Enter Gst Address</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gst Contact Number
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgst_contact_number(e.target.value)}
                  value={gst_contact_number}
                />
              </div>
              {gst_contact_number?.length == 0 && gst_contact_numberErr && (
                <p className="err">Enter Gst Contact Number</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gst Email
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgst_email(e.target.value)}
                  value={gst_email}
                />
              </div>
              {gst_email?.length == 0 && gst_emailErr && (
                <p className="err">Enter Gst Email</p>
              )}
            </div>
            <div className="col-md-12 mb-3">
              <div className="head-dest d-flex ac-jb">Bank Details</div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Bank Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setbank_name(e.target.value)}
                  value={bank_name}
                />
              </div>
              {bank_name?.length == 0 && bank_nameErr && (
                <p className="err">Enter Bank Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Account Holder Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setaccount_holder_name(e.target.value)}
                  value={account_holder_name}
                />
              </div>
              {account_holder_name?.length == 0 && account_holder_nameErr && (
                <p className="err">Enter Account Holder Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Account Number
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setaccount_number(e.target.value)}
                  value={account_number}
                  type={"number"}
                />
              </div>
              {account_number?.length == 0 && account_numberErr && (
                <p className="err">Enter Account Number</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Branch
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setbranch(e.target.value)}
                  value={branch}
                />
              </div>
              {branch?.length == 0 && branchErr && (
                <p className="err">Enter Branch</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Ifsc Code
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setifsc_code(e.target.value)}
                  value={ifsc_code}
                />
              </div>
              {ifsc_code?.length == 0 && ifsc_codeErr && (
                <p className="err">Enter Ifsc Code</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Upi ID
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setupi_id(e.target.value)}
                  value={upi_id}
                />
              </div>
              {upi_id?.length == 0 && upi_idErr && (
                <p className="err">Enter Upi ID</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Gpay Number
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setgpay_number(e.target.value)}
                  value={gpay_number}
                  type={"number"}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    if (e.target.value.length !== 10) {
                      e.target.setCustomValidity("invalid Number");
                    } else if (e.target.value.length == 10) {
                      e.target.setCustomValidity("");

                      setgpay_number(e.target.value);
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  maxlength={10}
                />
              </div>
              {gpay_number?.length == 0 && gpay_numberErr && (
                <p className="err">Enter Gpay Number</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Phone Pay Number
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setphone_pay_number(e.target.value)}
                  value={phone_pay_number}
                  type={"number"}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    if (e.target.value.length !== 10) {
                      e.target.setCustomValidity("invalid Number");
                    } else if (e.target.value.length == 10) {
                      e.target.setCustomValidity("");

                      setphone_pay_number(e.target.value);
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  maxlength={10}
                />
              </div>
              {phone_pay_number?.length == 0 && phone_pay_numberErr && (
                <p className="err">Enter Phone Pay Number</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 text-center mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default PropertyOwner;
